export function getNamaBulan(bulan) {
  const namaBulan = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];

  // bulan dikurangi 1 karena array mulai dari index 0
  return namaBulan[parseInt(bulan, 10) - 1] || "Bulan tidak valid";
}
